module.exports = __webpack_public_path__ + "img/withdraw-icon.6b4232eb.png";